import { Center, Loader, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export function AppLoading() {
  const { t } = useTranslation();

  return (
    <Center h='100dvh' bg='var(--mantine-color-body)' data-testid='app-loading'>
      <Stack align='center' gap='sm' role='status' aria-live='polite'>
        <Loader type='oval' aria-hidden='true' />
        <Text c='dimmed' fw={500}>
          {t('app.storagePrefetch.loading')}
        </Text>
      </Stack>
    </Center>
  );
}